<template>
  <div class="retrieve-pwd" data-part="newLogin">
    <div class='header'>
      <router-link to="" class="head-right">
        <mt-button icon="back" @click="goback()"></mt-button>
      </router-link>
      <div class="btn-box">
        <button :class="{active:tab=='1'}" @click="tabSwitch('1')">手机找回密码</button>
        <button :class="{active:tab=='2'}" @click="tabSwitch('2')">邮箱找回密码</button>
      </div>
      <span class="head-right"></span>
    </div>
    <div class="content-box">
      <div v-show="tab==1" class="phone-line" :class="{bottomLine:areaCode!=86}">
        <span class="country code-box" @click="pop2=true" :class="{bottomLine:areaCode==86}">
          <em>+{{areaCode}}</em>
          <i class="iconfont icon-xiala-copy"></i>
        </span>
        <div class="phone-in">
          <div class="separate-box" @click="inputClick('phoneDom')" v-show="areaCode==86">
            <i v-for="i in 11" :key="i" :class="{bottomLine:areaCode==86}">{{pwdArray[i-1]}}</i>
          </div>
          <input
            v-model="userParam.mobileInput"
            :class="{outStyle:phoneInput}"
            @focus="inputFocus('phoneInput')"
            @input="separateNum('mobileInput','phoneDom')"
            ref="phoneDom"
            type="number"
            placeholder="请输入手机号">
        </div>
        <!-- <separateBox numType="phone" :codeType="tab"></separateBox> -->
      </div>
      <div class="email-line bottomLine" v-show="tab==2">
        <input v-model="userParam.email" type="text" placeholder="请输入邮箱" >
      </div>
      <!-- <separateBox numType="code" :codeType="tab"></separateBox> -->
      <div class="validate-line">
        <div class="separate-box" @click="inputClick('codeDom')">
          <i v-for="i in codeNum" :key="i" :class="{little:codeNum==6}" class="bottomLine">{{codeArray[i-1]}}</i>
        </div>
        <input
          type="text"
          v-model="userParam.code"
          :class="{outStyle:codeInput}"
          @focus="inputFocus('codeInput')"
          @input="separateNum('code','codeDom')"
          ref="codeDom"
          placeholder="请输入验证码">
        <div class="right-btn">
          <span class="get-code" v-show="codestate==0" @click="setCode1()">获取验证码</span>
          <span v-show="codestate==1">已发送{{secondNum}}s</span>
        </div>
      </div>
      <div class="pwd-line">
        <input v-show="!pwdshow" type="password" placeholder="请设置新密码（6-16个字符）" v-model="userParam.pwdNum">
        <input v-show="pwdshow" type="text" placeholder="请设置新密码（6-16个字符）" v-model="userParam.pwdNum">
        <i class='iconfont icon-yanjing' :class="{noSee:!pwdshow,see:pwdshow}" @click="pwdshow=!pwdshow"></i>
      </div>
      <div class="voice-box" v-show="voiceShow&&tab==1">
        <span v-show="voiceState" @click="voiceVerification(this)">收不到短信？试试<em>语音验证</em></span>
        <span v-show="!voiceState">请注意接听语音验证电话（{{secondNum}}s）</span>
      </div>
      <div class="submit-line" @click="resetPwd">
        确定
      </div>
    </div>
    <mt-popup v-model="pop2" position="bottom" class="addresspop pickerPop">
      <areaBlock @codeChange="getArea" @closePop="pop2=false" v-show="pop2==true"></areaBlock>
    </mt-popup>
    <mt-popup
      v-model="popupVisible2"
      popup-transition="popup-fade"
      :modal="false"
      class="spinner-box">
      <mt-spinner class="pop-spinner" type="fading-circle"></mt-spinner>
    </mt-popup>

    <mt-popup
      :closeOnClickModal="false"
      v-model="patternVerification"
      class="tip-pop"
      popup-transition="popup-fade">
      <div id="TCaptcha"></div>
    </mt-popup>
  </div>
</template>

<script>
  import separateBox from "./separate-num.vue"
  import {ajax} from '../../assets/js/common'
  import {inputFocus,separateNum,countryCheck,resetPwd,patternCode,setCode,setEmail,speechVerification} from "../../assets/js/login-common"
  import areaBlock from './areaBlock.vue'
  export default{
    name:"forget-pwd",
    data(){
      return{
        tab:1,
        userParam:{
          "pwdNum":"",
          "mobileInput":"",
          "email":"",
          'code':"",
        },
        userType:"",
        boxShow:"",
        pwdSet:true,//true表示已设置密码，false未设置
        pwdshow:false,
        voiceShow:false,
        voiceState:true,
        secondNum:60,
        codestate:0,
        reltime:0,
        pop2:false,
        patternVerification:false,
        popupVisible2:false,
        popupVisible3:false,
        areaCode:86,
        phoneInput:false,
        codeInput:false,
        // pwdArray:[],
        // codeArray:[],
        nextStep:true,//控制下一步按钮的显示
        submitShow:false,//控制登录、注册按钮的显示
        loginRegBtn:true,
        countryslot:[
          {
            flex: 1,
            values: [],
            className: 'slot1',
            textAlign: 'center'
          },
        ],
        backType:false,//需保留信息
        patternParam:{
          ticket:"",
          businessId:""
        },
        newCodeType:"",//判断图形验证后需要再度访问的函数，voice为语音
      }
    },
    watch:{
      areaCode(){
        if(!this.backType){
          this.goOrigin();
        }
        else{
          this.backType=false;
        }
      },
      tab(){
        if(!this.backType){
          this.goOrigin();
        }
        else{
          this.backType=false;
        }
      },
      "userParam.code":function(val){
        // console.log(val);
      },
      "userParam.email":function(val){
        // console.log(val);
      },
    },
    computed:{
      pwdArray(){
        let array=this.userParam['mobileInput'].toString().split('');
        return array;
      },
      codeArray(){
        let array=this.userParam['code'].toString().split('');
        return array;
      },
      codeNum(){
        let val;
        if(this.tab==1){
          val=4;
        }
        else{
          // val=6;
          val=4;
        }
        return val;
      }
    },
    components:{
      separateBox,
      areaBlock
    },
    destroyed(){
      // sessionStorage.removeItem('setParam');
    },
    mounted(){
      this.$nextTick(()=>{
        this.countryCheck();
        let setParam=sessionStorage.getItem('setParam');
        if(setParam){
          setParam=JSON.parse(setParam);
          this.backType=true;
          this.tab=setParam.type;
          if(this.tab==1){
            this.areaCode=setParam.areaCode;
            this.userParam.mobileInput=setParam.mobile;
          }
          else{
            this.userParam.email=setParam.email;
            // console.log(this.userParam.email);
          }
          this.showCodeBox();
          this.inputFocus('phoneInput');
          this.separateNum("mobileInput","phoneDom");
        }

      })
    },
    methods:{
      /*恢复初始状态*/
      goOrigin(){
        for(let x in this.userParam){
          this.userParam[x]="";
        }
        // this.codeArray=[];
        // this.pwdArray=[];
      },
      resetPwd(){
        let arr=["code","sms","email"];
        let type=arr[this.tab];
        let param={
          code:this.userParam.code,
          password:this.userParam.pwdNum,
          type:type,
          area:this.areaCode,
          mobile:this.userParam.mobileInput,
          email:this.userParam.email
        };
        resetPwd(this,param);
      },
      getArea(val){
        this.pop2=false;
        this.areaCode=val;
      },
      loginSwitch(){
        if(this.boxShow=='code'){
          this.boxShow='pwd';
        }
        else if(this.boxShow=='pwd'){
          this.boxShow='code';
        }
      },
      /*注册*/
      register(val){
        console.log('register');
        return;
        if(this.rePwd==""){
          this.Toast("请先输入密码");
          return false;
        }
        let param={};
        if(this.tab==1){
          param={
            mobile:this.reUser,
            password:this.rePwd,
            code:this.reCode,
            checkmethod:"data",
            type:"sms",
            area:this.areaCode,
            invite_code:this.invite_code
          };
        }
        else if(this.tab==2){
          let name=$("#login-name").val();
          param={
            email:name,
            password:this.rePwd,
            code:this.reCode,
            checkmethod:"data",
            type:"email",
            invite_code:this.invite_code
          };
        }
        var that=this;
        this.redelay=0;
        // this.popupVisible2=true;
        ajax(this,this.extendApi.userReg,param,(data)=>{
          // this.popupVisible2=false;
          this.redelay=1;
          if(data.code==200){
            this.popupVisible2=false;
            if(this.tab==1){
              this.login(this.reUser,this.rePwd,this.areaCode);
            }
            if(this.tab==2){
              this.login(name,this.rePwd);
            }
          }
          else{
            Toast(data.message);
          }
        },"post");

      },
      /*发送验证码*/
      // setCode1(){
      //   var codetype="validate";
      //   var vparam;
      //   vparam="FzmRandom";
      //   if(this.tab==1){
      //     if(!this.voiceState){
      //       return false;
      //     }
      //     if(this.userParam.mobileInput==""){
      //       this.Toast("请先输入手机号");
      //       return false;
      //     }
      //     this.voiceShow=false;
      //     this.popupVisible2=true;

      //     this.codestate=1;
      //     return;

      //     setCode(this,codetype,vparam,this.userParam.mobileInput,(data)=>{
      //       this.popupVisible2=false;
      //     });
      //   }
      //   else if(this.tab==2){
      //     let name=$("#login-name").val();
      //     if(name==""){
      //       this.Toast("请先输入邮箱");
      //       return false;
      //     }
      //     this.popupVisible2=true;
      //     vparam="FzmDateTime|FzmRandom";
      //     setEmail(this,codetype,vparam,name,(data)=>{
      //       this.popupVisible2=false;
      //     });
      //   }
      // },
      //回调函数：验证码页面关闭时回调
      cbfn(retJson) {
        console.log(retJson);
        this.patternVerification=false;
        capDestroy();
        if (retJson.ret == 0) {
        // 用户验证成功
          this.patternParam.ticket=retJson.ticket;
          // this.Toast("验证成功");
          if(this.newCodeType=='voice'){
            this.voiceVerification();
          }
          else{
            this.setCode1();
          }

        }
        else {
            //用户关闭验证码页面，没有验证
        }
      },
      setCode1(){
        // if(!this.voiceState){
        //   return false;
        // }
        this.newCodeType="";
        if(this.tab==1&&this.userParam.mobileInput==''){
          this.Toast("手机不能为空");
          return false;
        }
        if(this.tab==2&&this.userParam.email==''){
          this.Toast("邮箱不能为空");
          return false;
        }
        /*只有在手机找回，并且语音验证已发送的情况下,阻止短信验证码发送*/
        if(this.tab==1&&!this.voiceState){
          return false;
        }
        /*只有在手机找回，并且点击短信发送时，隐藏语音发送*/
        if(this.tab==1&&this.voiceState){
          this.voiceShow=false;
        }
        // this.sendPwdEmail();

        var codetype="reset_password";
        var vparam;
        vparam="FzmDateTime|FzmRandom";
        this.popupVisible2=true;
        if(this.tab==1){
          /*test*/
          // this.codestate=1;
          // return;
          setCode(this,codetype,vparam,this.userParam.mobileInput,(data)=>{
            this.popupVisible2=false;
          },this.patternParam.ticket,this.patternParam.businessId);
        }
        else if(this.tab==2){
          // let name=$("#login-name").val();
          let name=this.userParam.email;
          if(name==""){
            this.Toast("请先输入邮箱");
            return false;
          }
          // vparam="FzmDateTime|FzmRandom";
          /*test*/
          // this.codestate=1;
          // return;

          setEmail(this,codetype,vparam,name,(data)=>{
            this.popupVisible2=false;
          },this.patternParam.ticket,this.patternParam.businessId);
        }
      },
      //当找回密码使用整合的短信邮件接口，使用该方法
      sendPwdEmail(){
        let param={};
        if(this.tab==1){
          param={
            mobile:this.userParam.mobileInput,
            os:"",
            area:this.areaCode,
            type:"sms"
          };
        }
        if(this.tab==2){
          param={
            email:this.userParam.email,
            os:"",
            type:"email"
          };
        }
        // param.platCode="zhaobi";
        param.ticket=this.patternParam.ticket;
        param.businessId=this.patternParam.businessId;
        this.popupVisible2=true;

        //test
        // this.Toast('发送成功');
        // this.codestate=1;
        // this.secondNum=60;
        // clearInterval(this.reltime);
        // this.reltime=setInterval(()=>{
        //   this.secondNum--;
        //   if(this.secondNum==50){
        //     if(this.tab==1){
        //       this.voiceShow=true;
        //     }
        //     clearInterval(this.reltime);
        //     this.codestate=0;
        //     this.secondNum=60;
        //   }
        // }, 1000);
        // return;


        ajax(this,this.extendApi.newreset,param,(data)=>{
          this.popupVisible2=false;
          if(data.code==200){
            console.log(data.data.isShow);
            if(data.data.isShow==0){
              console.log(324241);
              this.Toast('发送成功');
              this.codestate=1;
              this.secondNum=60;
              clearInterval(this.reltime);
              this.reltime=setInterval(function(){
                this.secondNum--;
                if(this.secondNum==0){
                  if(this.tab==1){
                    this.voiceShow=true;
                  }
                  clearInterval(this.reltime);
                  this.codestate=0;
                  this.secondNum=60;
                }
              }, 1000);
            }
            if(data.data.isShow==1){
              patternCode(data.data.data.jsUrl,this);
              this.patternParam.businessId=data.data.data.businessId;
            }
          }
          else{
            this.Toast(data.message);
          }
        },"post");
      },
      /*语音验证*/
      voiceVerification(){
        // if(this.reUser==""){
        //   this.Toast("请先输入手机号");
        //   return false;
        // }
        let param={
          area:this.areaCode,
          mobile:this.userParam.mobileInput,
          codetype:"reset_password",
          ticket:this.patternParam.ticket,
          businessId:this.patternParam.businessId
        };
        speechVerification(this,param);
      },
      inputClick(val){
        this.$refs[val].focus();
      },
      /*拆分input输入值*/
      separateNum(val,ref){
        separateNum(val,ref,this);
        // let array=this.userParam[val].toString().split('');
        // if(val=='mobileInput'){
        //   this.pwdArray=array;
        // }
        // else{
        //   this.codeArray=array;
        // }
        // if(array.length>10){
        //   this.$refs[ref].blur();
        // }
        // if(array.length==11){
        //   this.showCodeBox();
        // }
        // if(array.length==0){
        //   this.showCodeBox();
        // }
      },
      /*显示验证码输入框*/
      showCodeBox(){
        this.nextStep=false;
        this.submitShow=true;
        this.userType='login';
        if(this.userType=='reg'){
          this.boxShow='code';
        }
        else{
          if(this.pwdSet){
            this.boxShow='pwd';
          }
          else{
            this.boxShow='code';
          }
        }
      },
      /*手机输入框获取焦点*/
      inputFocus(val){
        if(val=='phoneInput'){
          if(this.areaCode==86){
            this.phoneInput=true;
          }
          else{
            this.phoneInput=false;
          }
        }
        else{
          this[val]=true;
          // if(this.tab==1){
          //   this[val]=true;
          // }
          // else{
          //   this[val]=false;
          // }
        }
      },
      /*手机国家获取*/
      countryCheck(){
        let param={
          type:"code",
        };
        this.countryslot[0].values=[];
        ajax(this,this.extendApi.countryList,param,(data)=>{
          if(data.code==200){
            for(let i=0;i<data.data.length;i++){
              this.countryslot[0].values.push(data.data[i]);
            }
          }
        },"GET");
      },
      selectSure(){
        this.pop2=false;
        this.areaCode=this.countryVal.code;
      },
      /*手机国家选择*/
      selectCountry(picker, values){
        this.countryVal=values[0];
      },
      tabSwitch(val){
        this.tab=val;
      }
    },
  }
</script>

<style>
  .retrieve-pwd{

  }
</style>



// WEBPACK FOOTER //
// src/views/login/retrievePwd.vue